import { AccountBox, DocumentScannerSharp } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { UUID } from "crypto";
import { rgb } from "d3";
import { useNavigate } from "react-router-dom";

import useStudyMetadataStore from "../useStudyMetadataStore";

const DisplayItems = ({ header, value }: { header: string; value?: string }) => {
  return (
    <Box sx={{ display: "flex", gap: "0.5rem" }} alignItems={"center"}>
      <Typography variant="body2" sx={{ color: rgb(66, 84, 102, 0.6), fontSize: "10px" }}>
        {header}
      </Typography>

      <Typography variant="body2" sx={{ fontSize: "12px" }}>
        {value ?? ""}
      </Typography>
    </Box>
  );
};

interface InterviewTranscriptProps {
  studyId: UUID;
  respondentId: UUID;
  fromRightPanel?: boolean;
}

export default function InterviewTranscript({
  studyId,
  respondentId,
  fromRightPanel = false,
}: InterviewTranscriptProps) {
  const navigate = useNavigate();
  const { study } = useStudyMetadataStore(studyId as UUID);

  const respondent = study?.respondents.find((_) => _.respondent_guid == respondentId);

  return (
    <Box sx={{ flex: 1, justifyContent: "space-between", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", gap: "0.5rem" }} alignItems={"center"}>
            <Box
              sx={{
                width: "44px",
                height: "44px",
                backgroundColor: "#00A3E0",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <DocumentScannerSharp sx={{ color: "white" }} />
            </Box>

            <Typography variant="h6" sx={{ fontSize: "20px", color: "#13294B" }}>
              Interview Transcript
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginTop: "1rem",
            justifyContent: "space-between",
          }}
        >
          <DisplayItems header="RESPONDENT ID" value={respondent?.respondent_id} />
          <DisplayItems header="PERSONA" value={respondent?.persona} />
          <DisplayItems header="HEIR" value={respondent?.heir} />
          <DisplayItems header="TARGET PRIORITY" value={respondent?.target_priority} />
          <DisplayItems header="SPECIALTY" value={respondent?.specialty} />
          <DisplayItems header="PRACTICE SEGMENT" value={respondent?.practice_segment} />
        </Box>
      </Box>

      <Button
        variant="outlined"
        sx={{ color: "#003087", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
        onClick={() => {
          if (fromRightPanel) {
            navigate(-2);
            return;
          }
          navigate(-1);
        }}
      >
        BACK TO INTERVIEWS
      </Button>
    </Box>
  );
}
